"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const react_router_dom_1 = require("react-router-dom");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const SearchListItemWrapper = styled_components_1.default.div `
  display: flex;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  border-radius: 10px;
  padding: 5px;
  cursor: pointer;
`;
const ItemImage = styled_components_1.default.img `
  width: 75px;
  height: 75px;
  border-radius: 5px;
  margin-right: 15px;
`;
const ImagePlaceholder = styled_components_1.default.div `
  width: 75px;
  height: 75px;
  flex-shrink: 0;
  border-radius: 5px;
  margin-right: 15px;

  background: linear-gradient(
    12deg,
    ${(props) => props.theme.palette.mainAppColor.dark} 5%,
    ${(props) => props.theme.palette.mainAppColor.light} 25%,
    ${(props) => props.theme.palette.mainAppColor.main} 100%
  );
`;
const ItemContent = styled_components_1.default.div `
  width: 100%;
`;
const PlaceAndTimeContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  min-height: 20px;
  width: 100%;
  margin-bottom: 5px;
  font-size: 13px;
  color: #807e7e;
`;
const Place = styled_components_1.default.span `
  display: flex;
  align-items: center;

  svg {
    font-size: 13px;
    margin-bottom: 2px;
  }

  p {
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const Time = styled_components_1.default.div `
  padding: 0 5px;
  margin-left: auto;
  white-space: nowrap;
`;
const Title = styled_components_1.default.div `
  margin: 0 0 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  .title {
    color: rgba(0, 0, 0, 87%);
  }
`;
const Book = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);

  .booking-circle {
    height: 8px;
    width: 8px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;

    &.green {
      background-color: #4cd964;
    }

    &.red {
      background-color: #ff3b30;
    }

    &.blue {
      background-color: #5ac8fa;
    }

    &.yellow {
      background-color: #ffcc00;
    }
  }
`;
const SearchListItem = ({ content, timezone, history, location }) => {
    const imgUrl = content && content.smallImage ? `${content.smallImage}` : null;
    const renderHours = () => {
        if (!content.showStartTime ||
            content.type === "website" ||
            content.type === "folder" ||
            content.type === "recipe") {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        const startTime = helpers_1.Helpers.getHourFromDate(content.start, timezone);
        const endTime = helpers_1.Helpers.getHourFromDate(content.end, timezone);
        return (react_1.default.createElement(Time, null,
            react_1.default.createElement(Typography_1.default, { variant: "caption" }, content.showEndTime ? `${startTime} - ${endTime}` : startTime)));
    };
    const renderBookingAvailability = () => {
        if (content.type === "recipe" ||
            content.type === "website" ||
            content.type === "folder" ||
            !content.bookable) {
            return null;
        }
        const bookingButtonText = content.availability
            ? content.availability.textsForDisplay.availabilityState
            : i18n_js_1.default.t("book_now");
        let bookingColor = "";
        switch (content.availability && content.availability.availabilityState) {
            case "available":
                bookingColor = "green";
                break;
            case "sold_out":
            case "not_bookable_anymore":
            case "not_yet_bookable":
            case "disabled":
            case "canceled":
                bookingColor = "red";
                break;
            case "user_has_active_booking":
                bookingColor = "blue";
                break;
            case "few_places_left":
                bookingColor = "yellow";
                break;
            default:
                bookingColor = "green";
        }
        return (react_1.default.createElement(Book, null,
            react_1.default.createElement("span", { className: `booking-circle ${bookingColor}` }),
            react_1.default.createElement(Typography_1.default, { variant: "caption" }, bookingButtonText)));
    };
    return (react_1.default.createElement(SearchListItemWrapper, { onClick: () => {
            if (content && content.type === "activity") {
                helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, { content });
                return;
            }
            if (content && content.type === "folder") {
                helpers_1.Helpers.closeSearchModal();
                const redirectLocation = content.deeplink
                    ? new URL(content.deeplink).pathname
                    : `/directory/folder/${content.title
                        .toLowerCase()
                        .replace(/ /g, "-")}`;
                history.push({
                    pathname: redirectLocation,
                    search: location.search,
                });
                return;
            }
            // TTR , this will open the link from search in a new window instead of a modal
            // if ( content && content.type === "website" ) {
            //     window.open( content.url, "_blank", "noopener,noreferrer" );
            //     return;
            // }
            if (content) {
                helpers_1.Helpers.openModal(modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS, {
                    activeItem: content,
                });
            }
        } },
        imgUrl ? (react_1.default.createElement(ItemImage, { className: "image-container", src: imgUrl })) : (react_1.default.createElement(ImagePlaceholder, null)),
        react_1.default.createElement(ItemContent, null,
            react_1.default.createElement(PlaceAndTimeContainer, null,
                typeof (content === null || content === void 0 ? void 0 : content.placeName) === "string" && (content === null || content === void 0 ? void 0 : content.placeName) && (react_1.default.createElement(Place, null,
                    react_1.default.createElement(Place_1.default, null),
                    react_1.default.createElement(Typography_1.default, { variant: "caption" }, content.placeName))),
                renderHours()),
            react_1.default.createElement(Title, null,
                react_1.default.createElement(Typography_1.default, { variant: "body2", className: "title" }, content.title)),
            renderBookingAvailability())));
};
const mapStoreToProps = (store) => ({
    timezone: store.getValue("timezone"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(SearchListItem));
